// extracted by mini-css-extract-plugin
export default {"documentsRequest":"RequestFile_documentsRequest__zrEYU","documentsRequestInput":"RequestFile_documentsRequestInput__q2rhm"};